module.exports = __webpack_public_path__ + "static/img/bg1.56623e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg1.png
// module id = RepZ
// module chunks = 3